import api from "../../utilities/interseptor";

const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API

export class ReportesService {
    static getIncidentesPorMes = (setStatus) => {
        api.get(apiUrl + `/monitor/get-incidentes-por-mes`)
            .then((res) => {
                setStatus(res.data)
            })
    }
    static getTendenciasIncidentes = (setStatus) => {
        api.get(apiUrl + `/monitor/get-tendencias-incidentes`)
            .then((res) => {
                setStatus(res.data)
            })
    }
    static getTendenciasBitacoras = (setStatus) => {
        api.get(apiUrl + `/monitor/get-tendencias-bitacoras-semana`)
            .then((res) => {
                setStatus(res.data)
            })
    }
    static getPorcentajeBitacorasYFallas = (setStatus) => {
        api.get(apiUrl + `/monitor/get-porcentaje-bitacoras-fallos-semana`)
            .then((res) => {
                setStatus(res.data)
            })
    }
    static getFallasSemana = (setStatus) => {
        api.get(apiUrl + `/monitor/get-fallas-semana`)
            .then((res) => {
                setStatus(res.data)
            })
    }
    static getTaxisPorSemana = (setStatus) => {
        api.get(apiUrl + `/monitor/get-taxis-por-semana`)
            .then((res) => {
                setStatus(res.data)
            })
    }
    static getTendenciasVisitasSemana = (setStatus) => {
        api.get(apiUrl + `/monitor/get-tendencias-visitas-semana`)
            .then((res) => {
                setStatus(res.data)
            })
    }
    static getTendenciasSensibilidadSemana = (setStatus) => {
        api.get(apiUrl + `/monitor/get-tendencias-sensibilidad-semana`)
            .then((res) => {
                setStatus(res.data)
            })
    }
}
